<template>
    <div class="form-input">
        <h4>{{label}}</h4>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            label: String
        }
    }
</script>

<style scoped lang="scss">
    .form-input {
        h4 {
            font-size  : 12px;
            text-align : left;
        }
    }

</style>